import { Bell } from 'lucide-react';
import { t } from '@transifex/native';
import { Button } from './button';
import { NotificationBadge } from './notification-badge';
import { cn } from '~/lib/utils';

type NotificationButtonProps = {
  unseenCountPromise: Promise<number>;
  onClick: () => void;
  isActive?: boolean;
  className?: string;
};

export function NotificationButton({
  unseenCountPromise,
  onClick,
  isActive,
  className,
}: NotificationButtonProps) {
  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn('relative size-10 rounded-sm', isActive && 'bg-primary-200', className)}
      onClick={onClick}
      aria-label={t('Notifications')}
    >
      <Bell className="size-5 text-text-900" />
      <NotificationBadge
        promise={unseenCountPromise}
        storageKey="unseenCommentsCount"
        className="absolute -top-1 -right-1"
      />
    </Button>
  );
}
